module.exports = __webpack_public_path__ + "static/media/LifebuoyHover.44b43b75.svg";